import React from 'react';

export const OrderCountryStep = ({ selectedCountry, updateCountry, setStep, COUNTRIES }) => {
  // Limit to available countries: Bahrain, UAE, Saudi Arabia, Philippines
  const limitedCountries = {
    BHD: COUNTRIES.BHD,
    AED: COUNTRIES.AED, 
    SAR: COUNTRIES.SAR,
    USD: COUNTRIES.USD // Philippines — uses USD pricing
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F7FBFC] to-[#E8F4F8] pt-20">
      <div className="max-w-2xl mx-auto px-4 py-6">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-[#011841] mb-2">Select Your Country</h2>
          <p className="text-[#033EA5]">Choose your location to see local pricing</p>
        </div>
        
        <div className="space-y-3">
          {Object.entries(limitedCountries).map(([code, country]) => (
            <button
              key={code}
              onClick={() => {
                updateCountry(code);
                setStep('products');
              }}
              className="w-full p-4 bg-[#F7FBFC] hover:bg-[#E8F4F8] border-2 border-[#19BFB7]/30 hover:border-[#19BFB7] rounded-xl transition-all duration-300 text-left shadow-md hover:shadow-lg"
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-[#011841] mb-1">{country.name}</h3>
                  <p className="text-[#033EA5] text-sm">Currency: {country.currency}</p>
                </div>
                <div className="text-2xl">{country.flag}</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
